import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"

/**
 * Sonda de quebra de tela — existe só para PROVAR que o alarme funciona.
 *
 * Um alarme de incêndio que ninguém nunca testou não é um alarme, é um
 * enfeite. Esta sonda derruba a tela de propósito para que se possa conferir,
 * de ponta a ponta, que a quebra chega até a telemetria com rota e papel.
 *
 * Duas travas, ambas necessárias:
 *
 * 1. **Só no ensaio.** O `vite.config.ts` aponta o build da branch `alfa` para
 *    o backend de ensaio; em `beta` e `main` a URL é a de produção e esta
 *    sonda vira código morto — não há string que o usuário possa digitar em
 *    produção que a acione.
 * 2. **Só sob pedido explícito** na URL (`?__crash=1`). Sem o parâmetro, o
 *    componente não faz absolutamente nada.
 *
 * O erro é disparado num render POSTERIOR ao mount (via timer) de propósito:
 * quebrar durante o primeiro render chegaria antes de os providers rodarem
 * seus efeitos, e o registro sairia sem o papel do usuário — justamente o
 * dado que se quer provar.
 */
const ENSAIO_PROJECT_REF = "rniqafkbcwihovbpcvid"

function isEnsaioBackend(): boolean {
  const url = import.meta.env.VITE_SUPABASE_URL as string | undefined
  return typeof url === "string" && url.includes(ENSAIO_PROJECT_REF)
}

export function CrashProbe() {
  const location = useLocation()
  const [boom, setBoom] = useState(false)

  const armed =
    isEnsaioBackend() && new URLSearchParams(location.search).has("__crash")

  useEffect(() => {
    if (!armed) return
    const timer = window.setTimeout(() => setBoom(true), 1000)
    return () => window.clearTimeout(timer)
  }, [armed])

  if (boom) {
    throw new Error(
      "CrashProbe: quebra de tela proposital para validar a telemetria de erro",
    )
  }

  return null
}
